import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAddressBookMagentoApiCall } from "../api/address-book.apis";
import { isLoadingAddressBook, isSuccessAddressBook } from "./address-book.selectors";
import { mapAddressBookMagentoResponse } from "../mapping/address-book.mapping";
import { StoreState } from "../../../store/store.interface";
import { getCart } from "../../cart/shop-cart/store/shop-cart.selectors";
import { getCustomerToken } from "../../customer/customer";

/*----- DECLARE THUNKS ------*/

export const fetchAddressBook = createAsyncThunk('addressBook/fetchAddressBook', async (_, thunkAPI) => {
  try {
    const state = thunkAPI.getState() as StoreState;
    const userBusinessUnit = getCart(state)?.userBusinessUnit;
    const customerToken = getCustomerToken(state);

    if (userBusinessUnit === 'HE') {
      // [SHOP-API-REMOVAL][WECOMM-20796] HE address-book previously called Shop
      // `/store/api/v1/address-book/address` via getLastAddressApiCall. Backend
      // confirmed Magento is the source of truth on PDP/Cart/Checkout/OC.
      console.warn(
        '[SHOP-API-REMOVAL][WECOMM-20796] fetchAddressBook: HE branch routed to Magento ' +
        '(Shop /store/api/v1/address-book/address removed).'
      );
    } else {
      // [SHOP-API-REMOVAL][WECOMM-20796] non-HE non-K12-admin previously called Shop
      // `/store/api/v1/address-book/seg` via getAddressBookApiCall. Routed to Magento.
      console.warn(
        '[SHOP-API-REMOVAL][WECOMM-20796] fetchAddressBook: non-HE branch routed to Magento ' +
        '(Shop /store/api/v1/address-book/seg removed). userBusinessUnit=%s',
        userBusinessUnit
      );
    }

    if (!customerToken) {
      console.error(
        '[SHOP-API-REMOVAL][WECOMM-20796] fetchAddressBook: customer token missing; ' +
        'cannot fall back to Shop (endpoint removed). userBusinessUnit=%s',
        userBusinessUnit
      );
      throw new Error('fetchAddressBook: customer token required');
    }

    const addressBook = await getAddressBookMagentoApiCall(customerToken);
    return mapAddressBookMagentoResponse(addressBook);
  }
  catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}, {
  condition: ((_data, { getState }) => {
    const state = getState() as StoreState;
    if (isLoadingAddressBook(state) || isSuccessAddressBook(state)) {
      return false;
    }
    return true;
  })
});
